/* LunaCeram – Karussells, Slider und m²-Rechner */
(function () {
  function initCarousel(root) {
    if (root.dataset.lcReady) return;
    root.dataset.lcReady = '1';
    var track = root.querySelector('.lc-track');
    var prev = root.querySelector('.lc-arrow--prev');
    var next = root.querySelector('.lc-arrow--next');
    if (!track) return;
    function step() { return Math.max(track.clientWidth * 0.8, 200); }
    function update() {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initSlider(root) {
    if (root.dataset.lcReady) return;
    root.dataset.lcReady = '1';
    var slides = root.querySelectorAll('.lc-slide');
    var dots = root.querySelectorAll('.lc-dot');
    if (slides.length < 2) return;
    var i = 0;
    var delay = parseInt(root.dataset.autoplay || '0', 10) * 1000;
    var timer;
    function go(n) {
      slides[i].classList.remove('is-active');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      if (dots[i]) dots[i].classList.add('is-active');
    }
    function start() { if (delay > 0) { stop(); timer = setInterval(function () { go(i + 1); }, delay); } }
    function stop() { if (timer) clearInterval(timer); }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); start(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); start(); }
      x0 = null;
    });
    start();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lc-carousel]').forEach(initCarousel);
    (scope || document).querySelectorAll('[data-lc-slider]').forEach(initSlider);
  }

  /* m²-Mengenrechner */
  if (!customElements.get('lc-m2-calculator')) {
    customElements.define('lc-m2-calculator', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.area = this.querySelector('[data-area]');
        this.waste = this.querySelector('[data-waste-select]');
        this.result = this.querySelector('[data-result]');
        this.qtyEl = this.querySelector('[data-qty]');
        this.totalEl = this.querySelector('[data-total]');
        this.apply = this.querySelector('[data-apply]');
        try { this.prices = JSON.parse(this.querySelector('[data-prices]').textContent); } catch (e) { this.prices = {}; }
        this.fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
        var update = function () { self.update(); };
        this.createWasteTabs();
        this.syncWasteTabs();
        this.area.addEventListener('input', update);
        this.waste.addEventListener('change', function () {
          self.syncWasteTabs();
          update();
        });
        document.addEventListener('change', function (e) {
          if (e.target && e.target.closest && e.target.closest('variant-picker, .variant-picker')) setTimeout(update, 300);
        });
        this.apply.addEventListener('click', function () { self.applyQty(); });
      }
      createWasteTabs() {
        if (!this.waste || this.wasteTabs || this.waste.options.length < 2) return;
        var source = this.waste;
        var wrapper = document.createElement('div');
        wrapper.className = 'lc-calc__waste-tabs';
        wrapper.setAttribute('role', 'group');
        wrapper.setAttribute('aria-label', 'Verschnitt auswählen');
        var style = document.createElement('style');
        style.textContent = [
          '.lc-calc__waste-tabs{display:flex;flex-wrap:wrap;gap:8px;margin-top:8px}',
          '.lc-calc__waste-tab{appearance:none;border:1px solid #c9c9c9;border-radius:5px;background:#fff;color:#222;padding:9px 14px;min-width:58px;font:inherit;line-height:1.2;cursor:pointer;transition:background-color .15s,border-color .15s,color .15s}',
          '.lc-calc__waste-tab:hover{border-color:#b69a68}',
          '.lc-calc__waste-tab.is-active{background:#b69a68;border-color:#b69a68;color:#111;font-weight:700}',
          '.lc-calc__waste-tab:focus-visible{outline:2px solid #222;outline-offset:2px}',
          '.lc-calc__waste-source{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}'
        ].join('');
        this.appendChild(style);
        Array.from(source.options).forEach(function (option) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'lc-calc__waste-tab';
          button.textContent = option.textContent.trim() || (option.value + '%');
          button.dataset.wasteValue = option.value;
          button.setAttribute('aria-pressed', option.selected ? 'true' : 'false');
          button.addEventListener('click', function () {
            source.value = option.value;
            source.dispatchEvent(new Event('change', { bubbles: true }));
          });
          wrapper.appendChild(button);
        });
        source.classList.add('lc-calc__waste-source');
        source.setAttribute('aria-hidden', 'true');
        source.tabIndex = -1;
        source.parentNode.insertBefore(wrapper, source.nextSibling);
        this.wasteTabs = wrapper;
      }
      syncWasteTabs() {
        if (!this.wasteTabs) return;
        var selected = String(this.waste.value);
        this.wasteTabs.querySelectorAll('button').forEach(function (button) {
          var active = button.dataset.wasteValue === selected;
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
          button.classList.toggle('is-active', active);
        });
      }
      form() {
        return document.querySelector('product-form-component form, form[action*="/cart/add"]');
      }
      variantId() {
        var f = this.form();
        var input = f && f.querySelector('[name="id"]');
        return input ? String(input.value) : Object.keys(this.prices)[0];
      }
      qty() {
        var a = parseFloat(String(this.area.value).replace(',', '.'));
        if (!a || a <= 0) return 0;
        var w = parseFloat(this.waste.value) || 0;
        return Math.ceil(a * (1 + w / 100));
      }
      selectedFormat() {
        var picker = document.querySelector('variant-picker');
        if (picker) {
          var fieldsets = picker.querySelectorAll('fieldset');
          for (var i = 0; i < fieldsets.length; i++) {
            var legend = fieldsets[i].querySelector('legend');
            if (legend && legend.textContent.trim().toLowerCase() === 'format') {
              var selected = fieldsets[i].querySelector('input:checked');
              if (selected) return selected.value;
            }
          }
        }
        var title = document.querySelector('h1');
        var match = title && title.textContent.match(new RegExp('(\\d+(?:[.,]\\d+)?)\\s*[x×]\\s*(\\d+(?:[.,]\\d+)?)(?:\\s*cm)?', 'i'));
        return match ? match[1] + '×' + match[2] : '';
      }
      slabArea() {
        var format = this.selectedFormat();
        var match = format.match(/^(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
        if (!match) return 0;
        var area = parseFloat(match[1].replace(',', '.')) * parseFloat(match[2].replace(',', '.')) / 10000;
        return area > 1.44 ? area : 0;
      }
      purchaseQty() {
        var q = this.qty();
        var slabArea = this.slabArea();
        return slabArea && q ? Math.ceil(q / slabArea) : q;
      }
      setupBreakdown() {
        if (this.detailEl) return;
        var qtyRow = this.qtyEl.parentElement;
        this.qtyLabelNode = qtyRow.firstChild;
        this.qtyUnitNode = this.qtyEl.nextSibling;
        var priceRow = this.totalEl.parentElement;
        this.priceLabelNode = Array.from(priceRow.childNodes).find(function (node) {
          return node.nodeType === Node.TEXT_NODE && node.textContent.trim();
        });
        this.detailEl = document.createElement('small');
        this.detailEl.className = 'lc-calc__detail';
        this.freightEl = document.createElement('small');
        this.freightEl.className = 'lc-calc__freight';
        this.estimateEl = document.createElement('div');
        this.estimateEl.className = 'lc-calc__estimate';
        this.unitPriceEl = document.createElement('small');
        this.unitPriceEl.className = 'lc-calc__unit-price';
        this.result.append(this.detailEl, this.unitPriceEl, this.freightEl, this.estimateEl);
      }
      update() {
        var neededArea = this.qty();
        if (!neededArea) { this.result.hidden = true; this.apply.disabled = true; return; }
        this.setupBreakdown();
        var cents = this.prices[this.variantId()] || 0;
        var slabArea = this.slabArea();
        if (slabArea) {
          var plates = Math.ceil(neededArea / slabArea);
          var coveredArea = plates * slabArea;
          var tileTotalCents = cents * plates;
          var crateCount = Math.ceil(plates / 20);
          var title = document.querySelector('h1');
          var isAzuvi = !!(title && title.textContent.indexOf('AZUVI') !== -1);
          var freightCents = isAzuvi ? crateCount * 115000 : 0;
          this.qtyLabelNode.textContent = 'Bestellmenge: ';
          this.qtyEl.textContent = plates;
          this.qtyUnitNode.textContent = ' Platten';
          this.priceLabelNode.textContent = 'Fliesenpreis: ';
          this.totalEl.textContent = this.fmt.format(tileTotalCents / 100);
          this.detailEl.textContent = 'Benötigt inkl. Verschnitt: ' + this.fmtArea(neededArea) + ' m². ' + plates + ' Platten decken ' + this.fmtArea(coveredArea) + ' m² ab (' + this.fmtArea(coveredArea - neededArea) + ' m² Mehrmenge durch volle Platten).';
          this.unitPriceEl.textContent = 'Plattenpreis: ' + this.fmt.format(cents / 100) + ' je Platte (' + this.fmtArea(slabArea) + ' m²) · ' + this.fmt.format(cents / 100 / slabArea) + ' je m².';
          this.freightEl.textContent = isAzuvi
            ? 'AZUVI Transport und Kiste: ' + this.fmt.format(freightCents / 100) + ' für ' + crateCount + ' angefangene 20er-Kiste(n); endgültig im Warenkorb bestätigt.'
            : 'Lieferkosten werden separat im Warenkorb berechnet.';
          this.estimateEl.textContent = isAzuvi
            ? 'Voraussichtlicher Gesamtpreis inklusive AZUVI-Transport: ' + this.fmt.format((tileTotalCents + freightCents) / 100)
            : 'Voraussichtlicher Fliesenpreis ohne Lieferung: ' + this.fmt.format(tileTotalCents / 100);
        } else {
          this.qtyLabelNode.textContent = 'Benötigte Menge: ';
          this.qtyEl.textContent = neededArea;
          this.qtyUnitNode.textContent = ' m²';
          this.priceLabelNode.textContent = 'Fliesenpreis (ohne Lieferung): ';
          this.totalEl.textContent = this.fmt.format((cents * neededArea) / 100);
          this.detailEl.textContent = 'Preisberechnung auf m²-Basis inklusive Verschnitt. Bei serienabhängiger Kartonabnahme kann die endgültige Liefermenge abweichen.';
          this.unitPriceEl.textContent = 'Einheitspreis: ' + this.fmt.format(cents / 100) + ' je m².';
          this.freightEl.textContent = 'Lieferkosten werden separat im Warenkorb berechnet.';
          this.estimateEl.textContent = '';
        }
        this.result.hidden = false;
        this.apply.disabled = false;
      }
      fmtArea(value) {
        return new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(value);
      }
      applyQty() {
        var q = this.purchaseQty();
        if (!q) return;
        var input = document.querySelector('product-form-component input[name="quantity"], quantity-selector-component input, input[name="quantity"]');
        if (!input) return;
        input.value = q;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        this.apply.textContent = 'Menge übernommen ✓';
        var btn = this.apply;
        setTimeout(function () { btn.textContent = 'Menge übernehmen'; }, 2000);
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

/* Seranit collection-card price display safeguard. Does not change cart prices. */
(function () {
  const seranitPrices = Object.freeze({
    'seranit-beton-preis-pro-m': 27,
    'seranit-antakya-preis-pro-m': 26,
    'seranit-arc-preis-pro-m': 26,
    'seranit-arcansas-preis-pro-m': 24,
    'seranit-smart-beton-preis-pro-m': 27,
    'seranit-casa-preis-pro-m': 26,
    'seranit-etna-preis-pro-m': 27,
    'seranit-fibre-preis-pro-m': 27,
    'seranit-imperial-preis-pro-m': 27,
    'seranit-lime-stone-preis-pro-m': 27,
    'seranit-luna-preis-pro-m': 27,
    'seranit-mold-preis-pro-m': 28,
    'seranit-riverstone-preis-pro-m': 27,
    'seranit-roller-stone-preis-pro-m': 27,
    'seranit-stone-age-preis-pro-m': 24,
    'seranit-stone-preis-pro-m': 27,
    'seranit-travertinum-ptv27-preis-pro-m': 27,
    'seranit-serenity-preis-pro-m': 27,
    'seranit-spectra-preis-pro-m': 24,
    'seranit-extreme-preis-pro-m': 24
  });
  const format = new Intl.NumberFormat('de-DE', {minimumFractionDigits:2,maximumFractionDigits:2});
  function correctCard(card) {
    const vendor = card.querySelector('.lc-pcard__title strong');
    if (!vendor || vendor.textContent.trim().toLowerCase() !== 'seranit') return;
    const anchor = card.querySelector('a.lc-pcard__title[href]');
    if (!anchor) return;
    const handle = anchor.getAttribute('href').split('?')[0].split('/').filter(Boolean).pop();
    let amount = seranitPrices[handle];
    if (!amount) {
      const match = anchor.textContent.match(/ab\s*(24|26|27|28)\s*€\s*\/\s*m(?:²|2)/i);
      if (match) amount = Number(match[1]);
    }
    if (!amount) return;
    const price = card.querySelector('.lc-pcard__price-main');
    if (price) {
      const desired = format.format(amount) + ' €';
      if (price.dataset.lcSeranitAmount !== String(amount) || !price.textContent.includes(desired)) {
        price.innerHTML = '<span>' + desired + '</span><small>/m²</small>';
        price.dataset.lcSeranitAmount = String(amount);
      }
    }
    const from = card.querySelector('.lc-pcard__price-from');
    if (from && from.textContent.trim() !== 'ab') from.textContent = 'ab';
    const note = card.querySelector('.lc-pcard__note');
    const expected = 'Nur volle Paletten · 150,00 € Versand je Palette · inkl. MwSt.';
    if (note && note.textContent.trim() !== expected) note.textContent = expected;
  }
  let scheduled = false;
  function run() { document.querySelectorAll('.lc-pcard').forEach(correctCard); }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  }
  function init() {
    run();
    const node = document.querySelector('#ResultsList') || document.body;
    if (node) new MutationObserver(schedule).observe(node, {childList:true, subtree:true});
    document.addEventListener('shopify:section:load', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
